<template>
  <div class="page-nBDetails">
    <Header  path='/productCenter'></Header>
    <div class="nBDetails-banner"></div>
    <div class="nBDetails-describe-1"></div>
    <div class="nBDetails-describe-2"></div>
    <div class="nBDetails-describe-3"></div>
    <Footer></Footer>
  </div>

</template>
<script>
     import Header from '@/components/Header/index.vue'
  import Footer from '@/components/Footer/index.vue'
  import router from '@/router'
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {

        
      }
    },

  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>